import { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { useHistory, useLocation } from 'react-router-dom';
import { useIntl } from '../../util/reactIntl';

import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';

import css from './ContactPage.module.css';
import ContactForm from '../../components/Cobe/ContactForm/ContactForm';
import { loadData } from './ContactPage.duck';
import Footer from '../../components/Cobe/Footer/Footer';

export class ContactPageComponent extends Component {
  static loadData() {
    return loadData();
  }

  render() {
    const { marketplaceName, scrollingDisabled, intl, currentUser, contactType } = this.props;

    const isLoggedIn = !!currentUser;

    const title = intl.formatMessage({
      id: 'ContactForm.title',
      defaultMessage: 'Contact Us',
    });

    return (
      <Page title={title} scrollingDisabled={scrollingDisabled}>
        <LayoutSingleColumn topbar={<TopbarContainer />} footer={<Footer />}>
          <div className={css.root}>
            <div className={css.content}>
              <ContactForm isLoggedIn={isLoggedIn}  />
            </div>
          </div>
        </LayoutSingleColumn>
      </Page>
    );
  }
}

const EnhancedContactPage = props => {
  const routeConfiguration = useRouteConfiguration();
  const config = useConfiguration();
  const history = useHistory();
  const intl = useIntl();

  return (
    <ContactPageComponent
      routeConfiguration={routeConfiguration}
      marketplaceName={config.marketplaceName}
      history={history}
      intl={intl}
      {...props}
    />
  );
};

const mapStateToProps = state => ({
  scrollingDisabled: state.ui && state.ui.scrollingDisabled,
  currentUser: state.user?.currentUser,
});

const mapDispatchToProps = dispatch => ({
  dispatchLoadData: () => dispatch(loadData()),
});

const ContactPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(EnhancedContactPage);

export default ContactPage;
